import { useTranslation } from "react-i18next";
import {
  Plan,
  RecurringInterval,
} from "../services/subscription/subscriptionModel";
import { useMemo, useState } from "react";
import SubmitButton from "./SubmitButton";
import DisplayPlan from "./DisplayPlan";

const ChoosePlan = ({
  plans,
  onChoice,
  showTrialHint = true,
}: {
  plans: Plan[];
  onChoice(choice: Plan, recurrency: RecurringInterval): void | Promise<any>;
  showTrialHint?: boolean;
}) => {
  const { t } = useTranslation(["subscription"]);
  // A recurrency is only offered when every plan has its Stripe price bound
  const hasMonthly = plans.every((plan) => plan.stripeMonthlyPrice);
  const hasAnnual = plans.every((plan) => plan.stripeAnnualPrice);
  const [planRecurrency, setPlanRecurrency] = useState<RecurringInterval>(
    hasAnnual ? "annual" : "monthly",
  );

  // Pro (company) plan first, PRO + (support) after
  const sortedPlans = useMemo(
    () =>
      [...plans].sort(
        (a, b) => Number(b.type === "company") - Number(a.type === "company"),
      ),
    [plans],
  );

  return (
    <div className="lblock">
      <div className="cblock">
        <h2 className="ui-st admin-choose_title">
          {t("subscription:CHOOSE_YOUR_SUBSCRIPTION")}
        </h2>
        {showTrialHint && (
          <div className="admin-hint">
            <strong>{t("subscription:TRIAL_NO_COMMITMENT")}</strong>
          </div>
        )}
      </div>

      {hasMonthly && hasAnnual && (
        <div className="cblock admin-recurrency">
          <div>{t("subscription:MENSUAL")}</div>
          <div>
            <button
              type="button"
              role="switch"
              aria-checked={planRecurrency === "annual"}
              aria-label={t("subscription:ANNUAL")}
              className="ui-toggle"
              onClick={() =>
                setPlanRecurrency((prev) =>
                  prev === "monthly" ? "annual" : "monthly",
                )
              }
            />
          </div>
          <div>{t("subscription:ANNUAL")}</div>
        </div>
      )}
      {hasMonthly && hasAnnual && planRecurrency === "annual" && (
        <div className="admin-hint">
          {t("subscription:ANNUAL_DISCOUNT_HINT")}
        </div>
      )}

      <div className="cblock ui-grid --g2">
        {sortedPlans.map((plan) => (
          <DisplayPlan
            plan={plan}
            key={plan.id}
            recurrency={planRecurrency}
            cta={
              <SubmitButton
                className="btn--2 --block"
                onClick={() => onChoice(plan, planRecurrency)}
              >
                {t("subscription:CHOOSE_THIS_PLAN")}
              </SubmitButton>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default ChoosePlan;
